/*
 * @Author: xuanyu 969718197@qq.com
 * @Date: 2023-06-14 09:27:06
 * @LastEditors: xuanyu 969718197@qq.com
 * @LastEditTime: 2024-01-08 15:16:02
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from '../../router'
import store from '../../store'

import axios from '@/axios/axios'
import api from '@/axios/index'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../../styles/tailwindcss.css';
Vue.use(Element)
import vueEsign from 'vue-esign'
Vue.use(vueEsign)

Vue.config.productionTip = false
Vue.prototype._http = axios
Vue.prototype._api = api

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
